





























import {Component, Prop, Vue} from 'vue-property-decorator'
import {uniqueId} from "@/util/uniqueId";

@Component
export default class NumberInput extends Vue {
    @Prop({
        default: 0
    })
    value!: number;

    @Prop({
        default: 0
    })
    min!: number;

    @Prop({
        default: Number.MAX_SAFE_INTEGER
    })
    max!: number;

    @Prop({
        default: false
    })
    isRequired!: boolean;

    @Prop({
        default: null
    })
    tooltip?: string | null;

    @Prop()
    label!: string;

    @Prop()
    name?: string;

    @Prop()
    error?: string | null;

    @Prop()
    warning?: string | null;

    private uid = uniqueId();

    private allowKeyInput(event: KeyboardEvent) {
        // only allow positive whole numbers
        if (!/\d/.test(event.key)) {
            return event.preventDefault();
        }
    }

    private updateValue(value: string) {
        const newNumber = Number(value);
        this.$emit('input', newNumber);
    }

    private formatValue() {
        if (this.value % 1 !== 0 || this.value < this.min || this.value > this.max) {
            const valueRounded = Math.max(this.max, Math.min(this.min, Math.round(this.value)));
            (this.$refs.input as HTMLInputElement).value = valueRounded.toString();
            this.$emit('input', valueRounded);
        }
    }
}
